/**
 * @generated SignedSource<<3133240f1151076460fe7527c7d2ed07>>
 * @relayHash 20f962b7fded29f4112b167bd49676c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8346be568da1ca3d59b43656aaeecc1204136933a0c9edc5ee7a3bffd1720553

import type { ConcreteRequest } from 'relay-runtime';
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseInputTextFormat = "ADF" | "PLAIN" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseInputText = {
  format: KnowledgeDiscoveryKeyPhraseInputTextFormat;
  text: string;
};
export type preloadAutohighlightsQuery$variables = {
  entityAri: string;
  inputText?: KnowledgeDiscoveryKeyPhraseInputText | null;
  jiraAssigneeAccountId?: string | null;
  jiraReporterAccountId?: string | null;
  workspaceId: string;
};
export type preloadAutohighlightsQuery$data = {
  readonly knowledgeDiscovery: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type preloadAutohighlightsQuery = {
  response: preloadAutohighlightsQuery$data;
  variables: preloadAutohighlightsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputText"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraAssigneeAccountId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraReporterAccountId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = [
  {
    "concreteType": "KnowledgeDiscoveryQueryApi",
    "kind": "LinkedField",
    "name": "knowledgeDiscovery",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAri"
          },
          {
            "kind": "Variable",
            "name": "inputText",
            "variableName": "inputText"
          },
          {
            "kind": "Variable",
            "name": "jiraAssigneeAccountId",
            "variableName": "jiraAssigneeAccountId"
          },
          {
            "kind": "Variable",
            "name": "jiraReporterAccountId",
            "variableName": "jiraReporterAccountId"
          },
          {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceId"
          }
        ],
        "kind": "LinkedField",
        "name": "keyPhrases",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "KnowledgeDiscoveryKeyPhrase",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "keyPhrase"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  }
                ]
              }
            ],
            "type": "KnowledgeDiscoveryKeyPhraseConnection"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadAutohighlightsQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadAutohighlightsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "20f962b7fded29f4112b167bd49676c6",
    "id": "8346be568da1ca3d59b43656aaeecc1204136933a0c9edc5ee7a3bffd1720553",
    "metadata": {},
    "name": "preloadAutohighlightsQuery",
    "operationKind": "query",
    "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
  }
};
})();

(node as any).hash = "2a72a5d970db2a37637d355335972efa";

export default node;
